import Login from '../auth/Login.js';
import useAuth from '../auth/useAuth.js';
import React from "react";
import { Route } from "react-router-dom";

function PrivateRoute({ children, roles, component: Component, ...rest }) {
    let auth = useAuth();

    const canView = () => {
        if (auth.user.id) {
            if (roles) {
                if (!auth.user.roles) {
                    return false;
                }
                var allowed = false;
                for (var i = 0; i < roles.length; i++) {
                    if (auth.user.roles.indexOf(roles[i]) !== -1) {
                        allowed = true;
                        break;
                    }
                }
                return allowed;
            } else {
                return true;
            }
        }
        return false;
    };
    return (
        <Route
            {...rest}
            render={({ location }) => {
                return (<React.Fragment>
                    {Component ? <Component /> : children}
                    {!canView() ? <Login embed={true} open={true} message="No permission to view this page, please login." homeButton={true} /> : null}
                </React.Fragment>);
            }}
        />
    );
}

export default PrivateRoute;